import { useEffect } from "react";

export function useDisableScroll(isOpen: boolean) {
  useEffect(() => {
    const html = document.documentElement;
    if (isOpen) {
      html.style.overflow = "hidden";
    } else {
      html.style.overflow = "";
    }

    return () => {
      html.style.overflow = "";
    };
  }, [isOpen]);
}
